/**
 * Thin wrapper around the Plausible custom-events API.
 * The script is injected via index.html; this hook is a no-op when Plausible
 * is not loaded (dev without the env var set, or an ad-blocker).
 *
 * Usage:
 *   const plausible = usePlausible();
 *   plausible("audit_form_submit");
 *   plausible("cta_click", { props: { label: "hero" } });
 */

import { useCallback } from "react";

type PlausibleFn = (
  event: string,
  options?: { props?: Record<string, string | number | boolean> },
) => void;

declare global {
  interface Window {
    plausible?: PlausibleFn;
  }
}

export function usePlausible(): PlausibleFn {
  return useCallback((event, options) => {
    if (typeof window.plausible === "function") {
      window.plausible(event, options);
    }
  }, []);
}
